import React, { Fragment } from "react";
import { styled, useTheme } from "@mui/material/styles";
import {
  Card,
  CardContent,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { IconInfoCircle } from "@tabler/icons";

// styles
const IconWrapper = styled("div")({
  position: "absolute",
  left: "-17px",
  bottom: "-15px",
  color: "#fff",
  transform: "rotate(25deg)",
  opacity: "0.35",
  "&> svg": {
    width: "60px",
    height: "60px",
  },
});

const StatsMetricCard = (props) => {
  const { icon, avatarcolor, label, time, children } = props;
  const theme = useTheme();

  return (
    <Fragment>
      <Grid
        container
        display="flex"
        alignItems="center"
        justifyContent="center"
        spacing={1}
      >
        <Grid
          item
          xs={12}
          display="flex"
          alignItems={"center"}
          justifyContent="center"
        >
          <Typography
            align="center"
            variant="h5"
            sx={{
              color:
                theme.palette.mode === "dark"
                  ? "white"
                  : theme.palette.primary.main,
            }}
          >
            {label}
          </Typography>
          {time && (
            <Tooltip title={time}>
              <IconButton
                sx={{
                  p: 0,
                  pl: 0.5,
                  color:
                    theme.palette.mode === "dark"
                      ? "white"
                      : theme.palette.primary.main,
                }}
              >
                <IconInfoCircle style={{ width: 13, height: 13 }} />
              </IconButton>
            </Tooltip>
          )}
        </Grid>

        <Grid item xs={12}>
          <Card
            sx={{
              background: avatarcolor,
              position: "relative",
              color: "#fff",
              // minHeight: 90,
            }}
          >
            <CardContent
              sx={{
                "&.MuiCardContent-root": { padding: 1 },
              }}
            >
              <IconWrapper>{icon}</IconWrapper>
              <Grid
                container
                display="flex"
                alignItems="start"
                justifyContent="center"
                spacing={2}
                paddingLeft={5}
              >
                {children}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default StatsMetricCard;
